import * as React from "react";
import { Province } from "@models/province";
import { Button, Divider, Modal, Table } from "antd";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import FormattedDateTime from "@components/custom/FormattedDateTime";
import Message from "@constants/message";
import ProvinceForm from "@components/provinces/Form";
import { PaginationDefaultParams } from "../custom/Paginator";
import { NavLink } from "react-router-dom";

type Props = {
  data: Province[];
  loading: boolean;
  deleteFn: (item: Province) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ProvincesTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteProvince = (item: Province): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 50,
      dataIndex: "index",
      key: "id",
      align:"right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.name" defaultMessage={`Name`} />,
      width: 300,
      align:"right",
      dataIndex: "name",
      key: "name"
    },
    {
      title: (
        <FormattedMessage
          id="app.creation_date"
          defaultMessage={`Creation Date`}
        />
      ),
      align:"center",
      width: 120,
      dataIndex: "created_at",
      key: "created_at",
      render: (text, record) => <FormattedDateTime date={text} />
    },
    {
      title: "",
      key: "actions",
      width: 90,
      align:"left",
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/provinces/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteProvince(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(ProvincesTable);
